export default function Footer() {
  return (
    <footer className="bg-emerald-900 text-white py-10 sm:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          <div>
            <img
              src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/10d9fc1b609b54364963a5ea239520dd.png"
              alt="Bucket List Golf"
              className="h-8 sm:h-10 w-auto mb-3 sm:mb-4"
            />
            <p className="text-emerald-100 text-xs sm:text-sm leading-relaxed">
              Creating unforgettable golf experiences at the nation's most coveted courses.
            </p>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-emerald-100 hover:text-white text-xs sm:text-sm transition-colors cursor-pointer">
                  About the Event
                </a>
              </li>
              <li>
                <a href="#registration" className="text-emerald-100 hover:text-white text-xs sm:text-sm transition-colors cursor-pointer">
                  Register Now
                </a>
              </li>
              <li>
                <a href="#faq" className="text-emerald-100 hover:text-white text-xs sm:text-sm transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact" className="text-emerald-100 hover:text-white text-xs sm:text-sm transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Connect With Us</h3>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/BucketListGolfSeries" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-emerald-800 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://www.instagram.com/BucketListGolfSeries" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-emerald-800 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-emerald-800 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-emerald-100 text-xs sm:text-sm text-center md:text-left">
            © 2025 Bucket List Golf Series. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-emerald-100 hover:text-white text-xs sm:text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
